import { useModal } from "matsuri-ui"
import { useCallback } from "react"
import { ConfirmRejectDialog } from "./CofirmRejectDialog"

export const useConfirmRejectDialog = ({
    onConfirmReject
}: {
    onConfirmReject: () => Promise<void>
}) => {
    const [_openModal, closeRejectModal] = useModal(ConfirmRejectDialog, {
        size: "sm"
    })

    const openRejectModal = useCallback(() => {
        _openModal({
            onConfirmButtonClick: onConfirmReject,
            onClose: closeRejectModal
        })
    }, [_openModal, onConfirmReject, closeRejectModal])

    return {
        openRejectModal,
        closeRejectModal
    }
}
